import { useEffect } from 'react';

import { useAuth } from 'react-oidc-context';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUserStore } from '@/stores/user.store';
import { getWorkspaceRoute } from '@/utils/routes';

function Redirect() {
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);
  const destination = params.get('destination');
  const navigate = useNavigate();
  const auth = useAuth();
  const userStore = useUserStore();

  useEffect(() => {
    if (auth.isAuthenticated && userStore.user) {
      if (destination) {
        navigate(destination);
      } else if (pathname && !pathname.startsWith('/redirect')) {
        navigate(getWorkspaceRoute(pathname));
      } else {
        navigate('/dashboard');
      }
    }
  }, [destination, navigate, auth.isAuthenticated, userStore.user, pathname]);

  return <></>;
}

export default Redirect;
